import React from "react";
import {
  RFID_BULK_UPLOAD_COLUMNS,
  getRfidBulkFieldValue,
} from "./rfidBulkUploadColumns";
import "./RfidUploadedErrorTable.css";

const COLUMNS = [
  { key: "rowNumber", label: "Row" },
  ...RFID_BULK_UPLOAD_COLUMNS,
];

const pushSplitMessages = (messages, value) => {
  String(value)
    .split("|")
    .map((part) => part.trim())
    .filter(Boolean)
    .forEach((part) => messages.push(part));
};

const getErrors = (row) => {
  const messages = [];
  const errors = row?.errors;

  if (errors && typeof errors === "object" && !Array.isArray(errors)) {
    Object.values(errors).forEach((value) => {
      if (Array.isArray(value)) {
        value.forEach((msg) => msg && messages.push(String(msg)));
      } else if (value) {
        messages.push(String(value));
      }
    });
  } else if (typeof errors === "string" && errors.trim()) {
    pushSplitMessages(messages, errors);
  }

  if (row?.validationErrors) {
    pushSplitMessages(messages, row.validationErrors);
  }

  if (row?.userRemarks) {
    pushSplitMessages(messages, row.userRemarks);
  }

  if (row?.remarks) {
    pushSplitMessages(messages, row.remarks);
  }

  return [...new Set(messages)];
};

const RfidUploadedErrorTable = ({ data = [] }) => {
  if (!data.length) return null;

  return (
    <div className="rfid-bulk-error-table-wrap">
      <div className="rfid-bulk-error-count">
        <i className="fa-solid fa-triangle-exclamation"></i>
        Total errors: {data.length}
      </div>

      <div className="rfid-bulk-error-table-scroll table-responsive">
        <table className="table table-sm mb-0 rfid-bulk-error-table">
          <thead>
            <tr>
              {COLUMNS.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
              <th className="rfid-bulk-error-col">Errors</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              const errors = getErrors(row);
              const rowKey = row?.rowNumber ?? index;

              return (
                <tr key={`${rowKey}-${index}`}>
                  {COLUMNS.map((col) => (
                    <td key={col.key}>
                      {col.key === "rowNumber" ? (
                        row?.rowNumber === 0 ||
                        row?.rowNumber === "0" ||
                        row?.rowNumber == null ? (
                          "-"
                        ) : (
                          `#${getRfidBulkFieldValue(
                            { rowNumber: row.rowNumber },
                            { keys: ["rowNumber"] }
                          )}`
                        )
                      ) : col.key === "status" ? (
                        <span className="rfid-bulk-status-badge">
                          {getRfidBulkFieldValue(row, col)}
                        </span>
                      ) : (
                        getRfidBulkFieldValue(row, col)
                      )}
                    </td>
                  ))}
                  <td>
                    {errors.length ? (
                      <div className="d-flex flex-column gap-1">
                        {errors.map((msg, i) => (
                          <span key={i} className="rfid-bulk-error-badge">
                            {msg}
                          </span>
                        ))}
                      </div>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RfidUploadedErrorTable;
